import { Component, Input } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MxBaseComponent } from 'src/app/core/base/mx.base-component';

@Component({ standalone: false,
  selector: 'mx-table-operation-tiered-menu-button',
  templateUrl: './mx.table-operation-tiered-menu-button.component.html',
  styleUrls: ['./mx.table-operation-tiered-menu-button.component.scss'],
})
export class MxTableOperationTieredMenuButtonComponent extends MxBaseComponent {
  @Input() items: MenuItem[];
  @Input() visible: boolean;
}
